import React from 'react'
import styled from '@emotion/styled'
import { colors } from 'src/styles'
import PropTypes from 'prop-types'

const BgSelectorWrapper = styled.div`
  background-color: ${({backgroundColor}) => backgroundColor && backgroundColor };
`

export default function BgSelector({ bgColor = 'default', color, style, pageColors = {mainColor: null}, ...rest}) {
  const { mainColor } = pageColors;
  let backgroundColor = 'transparent';
  if(bgColor && bgColor !== 'white' && mainColor) {
    backgroundColor = colors[`${ mainColor}Lighten`];
  } else if(color) {
    backgroundColor = colors[`${ color}Lighten`];  
  } else {
    backgroundColor = colors[bgColor]
  }

  return (
    <BgSelectorWrapper 
      backgroundColor={backgroundColor}
      {...rest}
    />
  )
}

BgSelector.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  pageColors: PropTypes.object,
  style: PropTypes.object
}
